import React, { useState } from "react";
import axios from "axios";

const baseurl = "https://growmaxbackend.ogcs.co.in";

const SimpleBookingForm = () => {
  const [form, setForm] = useState({
    eventType: "",
    secondField: "",
    name: "",
    email: "",
    phone: "",
    event: "",
    attendees: "",
    location: "",
    eventDate: "",
    eventTime: "",
    notes: ""
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(`${baseurl}/api/bookings`, form);
      alert("Booking Successful ✅");

      setForm({
        eventType: "",
        secondField: "",
        name: "",
        email: "",
        phone: "",
        event: "",
        attendees: "",
        location: "",
        eventDate: "",
        eventTime: "",
        notes: ""
      });

    } catch (err) {
      console.error(err);
      alert("Error submitting form ❌");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center px-4 py-12 overflow-hidden">

      {/* Background Glow */}
      <div className="absolute inset-0 -z-10 bg-gradient-to-br from-fuchsia-100 via-white to-sky-100" />
      <div className="absolute -inset-40 bg-gradient-to-br from-fuchsia-400/30 via-cyan-300/20 to-amber-300/20 blur-3xl animate-pulse" />

      <div className="w-full max-w-4xl bg-white/80 backdrop-blur-xl shadow-2xl rounded-3xl p-8 border border-white/40">

        {/* Header */}
        <div className="text-center mb-10">
          <h2 className="text-4xl font-extrabold bg-gradient-to-r from-fuchsia-600 via-sky-600 to-amber-500 bg-clip-text text-transparent">
            Event Booking
          </h2>
          <p className="text-gray-600 mt-3">
            Plan your event with GrowMax-OGCS professionally
          </p>
        </div>

        <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6">

          {/* Event Type */}
          <div className="field">
            <label className="label">Event Type</label>
            <select name="eventType" value={form.eventType} onChange={handleChange} required className="input">
              <option value="">Select</option>
              <option value="Corporate">Corporate</option>
              <option value="College">College</option>
            </select>
          </div>

          {/* Organization */}
          <div className="field">
            <label className="label">Organization / College</label>
            <input name="secondField" value={form.secondField} onChange={handleChange} required className="input" />
          </div>

          {/* Name */}
          <div className="field">
            <label className="label">Full Name</label>
            <input name="name" value={form.name} onChange={handleChange} required className="input" />
          </div>

          {/* Email */}
          <div className="field">
            <label className="label">Email Address</label>
            <input type="email" name="email" value={form.email} onChange={handleChange} required className="input" />
          </div>

          {/* Phone */}
          <div className="field">
            <label className="label">Phone Number</label>
            <input name="phone" value={form.phone} onChange={handleChange} required className="input" />
          </div>

          {/* Event */}
          <div className="field">
            <label className="label">Event Name</label>
            <input name="event" value={form.event} onChange={handleChange} required className="input" />
          </div>

          {/* Attendees */}
          <div className="field">
            <label className="label">Attendees</label>
            <input type="number" name="attendees" value={form.attendees} onChange={handleChange} required className="input" />
          </div>

          {/* Location */}
          <div className="field">
            <label className="label">Location</label>
            <input name="location" value={form.location} onChange={handleChange} required className="input" />
          </div>

          {/* Date */}
          <div className="field">
            <label className="label">Event Date</label>
            <input type="date" name="eventDate" value={form.eventDate} onChange={handleChange} required className="input" />
          </div>

          {/* Time */}
          <div className="field">
            <label className="label">Event Time</label>
            <input type="time" name="eventTime" value={form.eventTime} onChange={handleChange} required className="input" />
          </div>

          {/* Notes */}
          <div className="field md:col-span-2">
            <label className="label">Additional Notes</label>
            <textarea name="notes" value={form.notes} onChange={handleChange} className="input h-28 resize-none" />
          </div>

          {/* Button */}
          <div className="md:col-span-2">
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-gradient-to-r from-fuchsia-600 via-rose-500 to-orange-500 text-white py-3 rounded-xl font-semibold shadow-lg hover:scale-[1.02] transition disabled:opacity-70"
            >
              {loading ? "Submitting..." : "Submit Booking"}
            </button>
          </div>

        </form>
      </div>

      {/* Styles */}
      <style>
        {`
          .field {
            display: flex;
            flex-direction: column;
            gap: 6px;
          }

          .label {
            font-size: 13px;
            font-weight: 600;
            color: #374151;
          }

          .input {
            width: 100%;
            padding: 10px 14px;
            border-radius: 10px;
            border: 1px solid #e5e7eb;
            font-size: 14px;
            transition: all 0.2s;
          }

          .input:focus {
            outline: none;
            border-color: #d946ef;
            box-shadow: 0 0 0 2px rgba(217, 70, 239, 0.2);
          }
        `}
      </style>

    </section>
  );
};

export default SimpleBookingForm;